import C from '../actions/constants'

export const densityCorrection = (state = {}, action) => {
    switch (action.type) {
        case C.SET_DENSITY_CORRECTION_VALUES:
            return { ...state, ...action.payload }
        default:
            return state
    }
}